import { useBootstrapExperiments } from '@/features/experiments';
import { watch } from 'vue';
import { trackEvent } from '@/entities/sogu';

export const useCityTagsCollectionsExperiment = () => {
  const EXP_NAME = 'citytags_collections';
  const TARGET_EXP_VARIANT = 'citytags_collections';
  const { experiments, isExperimentVariantActive } = useBootstrapExperiments();

  const isExpActive = computed(() => {
    return isExperimentVariantActive(EXP_NAME, TARGET_EXP_VARIANT);
  });

  watch(
    () => isExpActive.value,
    () => {
      if (experiments.value[EXP_NAME]) {
        trackEvent('experiments.hit', {
          experiment: EXP_NAME,
          variant: isExpActive.value ? TARGET_EXP_VARIANT : 'original',
        });
      }
    },
    { immediate: true, deep: true },
  );

  return {
    isExpActive,
  };
};
